interface EventObject {
  formName: string;
  event: string;
  eventCallback: any;
  values: { [key: string]: string };
  pageVariant?: string;
}

class TrackingHelper {

  public trackFormSubmit(form: HTMLFormElement, response: Response) {
    let fullEvent: EventObject;
    const trackValues: { [key: string]: string } = {};
    const trackEvent = form.dataset.trackEvent || false;

    if (!trackEvent) {
      return;
    }

    try {
      fullEvent = JSON.parse(trackEvent)
    } catch (e) {
      console.error('No valid JSON in tracking event: ' + trackEvent)
    }

    if (fullEvent.formName) {
      const trackElements: NodeListOf<HTMLInputElement> = form.querySelectorAll('[data-datalayermapping]')

      if (trackElements.length > 0) {
        trackElements.forEach(trackElement => trackValues[trackElement.dataset.datalayermapping + '_' + fullEvent.formName] = trackElement.value)
      }

      // @ts-expect-error window.pageVariant is added by typoscript (see bls_abtest extension)
      if (typeof window.pageVariant !== typeof undefined && window.pageVariant !== 'default') {
        // @ts-expect-error see above
        fullEvent['pageVariant'] = window.pageVariant;
      }
    }

    fullEvent['values'] = trackValues;
    fullEvent['eventCallback'] = () => {
      if (response.redirected) {
        window.location.href = response.url;
      }
    };

    if ((<any>window).dataLayer) {
      (<any>window).dataLayer.push(fullEvent);
    }
  }

}

export { TrackingHelper };
